export const DEPRECIATION = {
  initial_used_factor: 0.82,
  age: {
    end_of_life_years: 10,
    power: 0.55,
    floor_pct: 0.12,
  },
};

export const ADJUSTMENTS = {
  model_desirability: {
    cookie: {
      'g35': 1.08,
      'g4': 1.08,
      'g3': 0.92,
      _default: 1.0,
    },
    tonfly: {
      'tfx': 1.08,
      '2x': 1.05,
      '2.5x': 1.05,
      '3x': 1.05,
      _default: 1.0,
    },
    skyhelmets: {
      'fujin': 1.08,
      _default: 1.0,
    },
    _default_manufacturer: 1.0,
    _unknown_manufacturer: 0.95,
  },
  condition: {
    'condition-like-new': 1.10,
    'condition-good': 1.0,
    'condition-fair': 0.88,
    'condition-poor': 0.70,
    _default: 1.0,
  },
  color: {
    premium_colors: ['black', 'matte black', 'carbon'],
    premium: 1.0,
    neutral_colors: ['white', 'blue', 'grey', 'gray'],
    neutral: 1.0,
    penalty_colors: ['pink', 'neon', 'custom paint'],
    penalty: 0.95,
    _default: 1.0,
  },
};

export const MANUFACTURERS = {
  cookie: {
    brand_key: 'cookie',
    models: {
      'g35':  { new_price_eur: 452 },
      'g4':   { new_price_eur: 470 },
      'g3':   { new_price_eur: 396 },
      'm3':   { new_price_eur: 161 },
      'fuel': { new_price_eur: 257 },
      'ozone': { new_price_eur: 104 },
    },
  },
  bonehead: {
    brand_key: 'bonehead',
    models: {
      'dynamic': { new_price_eur: 405 },
      'fusion':  { new_price_eur: 405 },
      'nicos':   { new_price_eur: 422 },
      'x-sport': { new_price_eur: 274 },
      'cs1':     { new_price_eur: 1388 },
    },
  },
  tonfly: {
    brand_key: 'tonfly',
    models: {
      'tfx': { new_price_eur: 498 },
      'ice': { new_price_eur: 348 },
      '2x':  { new_price_eur: 365 },
      '2.5x': { new_price_eur: 365 },
      '3x':  { new_price_eur: 466 },
      'vid': { new_price_eur: 408 },
    },
  },
  skyhelmets: {
    brand_key: 'skyhelmets',
    models: {
      'fujin': { new_price_eur: 550 },
    },
  },
  kiss: {
    brand_key: 'kiss',
    models: {
      'kiss': { new_price_eur: 303 },
    },
  },
  parasport: {
    brand_key: 'parasport',
    models: {
      'altix':      { new_price_eur: 213 },
      'aeronaut':   { new_price_eur: 191 },
      'jed-a-pro':  { new_price_eur: 200 },
      'z1':         { new_price_eur: 180 },
      'zx':         { new_price_eur: 500 },
    },
  },
  rawa: {
    brand_key: 'rawa',
    models: {
      '_default': { new_price_eur: 150 },
    },
  },
};
